import styled from "styled-components";

export const CustomCardWrapper = styled.div`
  padding: 16px;
`;
